import Vue from "vue";
import Router from "vue-router";

import ViewPc from "@/page/PcView";
import ViewMobile from "@/page/MobileView";

import PcContainer from "@/page/PcContainer";
import MobileContainer from "@/page/MobileContainer";

// basic
import PcPartners from "@/page/PcPartners";
import MobilePartners from "@/page/MobilePartners";

// 바로돌봄
import PcBarocare from "@/page/PcBarocare";
import MobileBarocare from "@/page/MobileBarocare";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        { path: "/", name: "Home", component: PcContainer },
        {
            path: "/view",
            name: "view",
            component: ViewPc,
        },
        {
            path: "/partners",
            name: "partners",
            component: PcPartners,
        },
        {
            path: "/barocare",
            name: "barocare",
            component: PcBarocare,
        },

        // { path: "/", name: "Home", component: MobileContainer },
        // {
        //     path: "/view",
        //     name: "view",
        //     component: ViewMobile,
        // },
        // {
        //     path: "/partners",
        //     name: "partners",
        //     component: MobilePartners,
        // },
        // {
        //     path: "/barocare",
        //     name: "barocare",
        //     component: MobileBarocare,
        // },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js